export default {
    path: '/common',
    name: 'resource',
    component: () => import('../../views/Layout/index'),
    meta: {
      title: '资源',
      // keepAlive: false
    },
    children: [
      {
        // 重定向
        path: 'kdredirect',
        name: 'kdredirect',
        component: () => import('../../components/KindEditor/Redirect'),
        meta: { title: '重定向', keepAlive: false }
      },
    ]
  }